import React from "react";
import UpdateLinks from "./UpdateLinks";
import { useParams } from "react-router-dom";

export function DisplayLinks(props) {
  const param = useParams();
  return <UpdateLinks param={param} {...props} />;
}
